import { render, staticRenderFns } from "./OxideFormWidget.vue?vue&type=template&id=b7e598c8&scoped=true&"
import script from "./OxideFormWidget.vue?vue&type=script&lang=js&"
export * from "./OxideFormWidget.vue?vue&type=script&lang=js&"
import style0 from "./OxideFormWidget.vue?vue&type=style&index=0&id=b7e598c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e598c8",
  null
  
)

export default component.exports